import { render, staticRenderFns } from "./updateZj.vue?vue&type=template&id=4c9b9b3f&scoped=true&"
import script from "./updateZj.vue?vue&type=script&lang=ts&"
export * from "./updateZj.vue?vue&type=script&lang=ts&"
import style0 from "./updateZj.vue?vue&type=style&index=0&id=4c9b9b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b9b3f",
  null
  
)

export default component.exports